var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlockModalBackground = function SvgUnlockModalBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 316,
    viewBox: "0 0 364 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2090_98325)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.2849,
    y: 134.061,
    width: 17.4206,
    height: 49.981,
    rx: 4,
    transform: "rotate(60 25.2849 134.061)",
    fill: "#61D5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.972 175.422C497.973 174.35 502.086 176.724 503.158 180.725L526.584 268.153C527.656 272.154 525.282 276.266 521.281 277.338L249.664 350.118C245.663 351.19 241.551 348.815 240.479 344.814L217.053 257.387C215.981 253.386 218.355 249.274 222.356 248.202L493.972 175.422Z",
    stroke: "#DAD8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_98325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 364,
    height: 316,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlockModalBackground);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzY0IiBoZWlnaHQ9IjMxNiIgdmlld0JveD0iMCAwIDM2NCAzMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yMDkwXzk4MzI1KSI+CjxyZWN0IHg9IjI1LjI4NDkiIHk9IjEzNC4wNjEiIHdpZHRoPSIxNy40MjA2IiBoZWlnaHQ9IjQ5Ljk4MSIgcng9IjQiIHRyYW5zZm9ybT0icm90YXRlKDYwIDI1LjI4NDkgMTM0LjA2MSkiIGZpbGw9IiM2MUQ1RUUiLz4KPHBhdGggZD0iTTQ5My45NzIgMTc1LjQyMkM0OTcuOTczIDE3NC4zNSA1MDIuMDg2IDE3Ni43MjQgNTAzLjE1OCAxODAuNzI1TDUyNi41ODQgMjY4LjE1M0M1MjcuNjU2IDI3Mi4xNTQgNTI1LjI4MiAyNzYuMjY2IDUyMS4yODEgMjc3LjMzOEwyNDkuNjY0IDM1MC4xMThDMjQ1LjY2MyAzNTEuMTkgMjQxLjU1MSAzNDguODE1IDI0MC40NzkgMzQ0LjgxNEwyMTcuMDUzIDI1Ny4zODdDMjE1Ljk4MSAyNTMuMzg2IDIxOC4zNTUgMjQ5LjI3NCAyMjIuMzU2IDI0OC4yMDJMNDkzLjk3MiAxNzUuNDIyWiIgc3Ryb2tlPSIjREFEOEZGIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjA5MF85ODMyNSI+CjxyZWN0IHdpZHRoPSIzNjQiIGhlaWdodD0iMzE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";